export class TaskFilterForm {
  status: string;
  number: string;
  type: string;
  code: string;
  city: string;
  county: string;
  receiveDate: string;

  pageSize = 10;
  pageOffset = 0;
}
